export const helpCs = {
  'help.nav': 'Nápověda',
  'help.title': 'Nápověda a první kroky',
  'help.intro': 'Vyberte, co chcete udělat. Krátké postupy vás zavedou na správnou obrazovku a vysvětlí, jak poznat výsledek.',
  'help.scope': 'Postupy odpovídají vašim aktuálním oprávněním. Odkazy pouze otevírají obrazovky; nic za vás neukládají ani neschvalují.',
  'help.organization': 'Organizace',
  'help.noOrganization': 'Organizace není vybraná',
  'help.choose': 'Co potřebujete udělat?',
  'help.steps': 'Postup krok za krokem',
  'help.result': 'Jak poznáte výsledek',
  'help.back': 'Zpět na pracovní plochu',
  'help.empty': 'Pro vaše současná oprávnění není dostupný žádný pracovní postup. Ověřte přístup se správcem organizace.',
  'help.unavailable': 'Požadovaný postup není ve vašem aktuálním přístupu dostupný. Vyberte některý z nabídnutých postupů.',
  'help.context': 'Návod k této obrazovce',
  'help.entryTitle': 'Začínáte s Eventem?',
  'help.entryBody': 'Najděte svůj první úkol a rovnou otevřete správné místo. Návody jsou přizpůsobené vašim oprávněním.',
  'help.entryAction': 'Zobrazit první kroky',
  'help.safetyTitle': 'Máte vždy poslední slovo',
  'help.safetyBody': 'Návod neprovádí akce automaticky. Před uložením, zveřejněním nebo schválením zkontrolujte organizaci, vybranou akci a údaje. Samotné přečtení kroku neznamená, že je úkol hotový.',
};

export const helpEn: Record<keyof typeof helpCs, string> = {
  'help.nav': 'Help',
  'help.title': 'Help and first steps',
  'help.intro': 'Choose what you want to do. Short guides take you to the right screen and explain how to recognise the result.',
  'help.scope': 'Guides reflect your current permissions. Links only open screens; they never save or approve anything for you.',
  'help.organization': 'Organization',
  'help.noOrganization': 'No organization selected',
  'help.choose': 'What would you like to do?',
  'help.steps': 'Step-by-step guide',
  'help.result': 'How to recognise the result',
  'help.back': 'Back to your workspace',
  'help.empty': 'No workflow is available for your current permissions. Check your access with an organization administrator.',
  'help.unavailable': 'The requested guide is not available with your current access. Choose one of the available guides.',
  'help.context': 'Guide for this screen',
  'help.entryTitle': 'New to Event?',
  'help.entryBody': 'Find your first task and open the right place straight away. Guides are tailored to your permissions.',
  'help.entryAction': 'Show first steps',
  'help.safetyTitle': 'You stay in control',
  'help.safetyBody': 'The guide never performs actions automatically. Before saving, publishing or approving, check the organization, selected event and details. Reading a step does not mean the task is complete.',
};
